import CredentialType from "./credential-type.enum";

export default class Credential {
  id: number;
  type: CredentialType;
  other: string;
  licenseId: string;
  issueState: string;
  validFromDatetime: Date;
  validToDatetime: Date;
  active: boolean;
  deleted: boolean = false;
  operatingAs: boolean;
  createdDatetime: Date;
  updatedDatetime: Date;
  createdBy: string;
  updatedBy: string;
}



// WEBPACK FOOTER //
// ./src/models/resource-management/credential.ts